import type { ComponentProps } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useOrgTo } from '@/hooks/use-tab-organization'

export type OrgLinkProps = ComponentProps<typeof Link>
export type OrgNavLinkProps = ComponentProps<typeof NavLink>

/** `Link` whose `href` keeps the tab organization, so ctrl/middle-click and copy-link open in it. */
export function OrgLink({ to, ...props }: OrgLinkProps) {
  const organizationTo = useOrgTo(to)
  return <Link {...props} to={organizationTo} />
}

export function OrgNavLink({ to, ...props }: OrgNavLinkProps) {
  const organizationTo = useOrgTo(to)
  return <NavLink {...props} to={organizationTo} />
}
